import { PrimaryButton } from "../Buttons/PrimaryButton";

interface EntryFinishPopupProps {
  onClickShare: () => void;
  onClose: () => void;
}

export const EntryFinishPopup: React.FC<EntryFinishPopupProps> = ({ onClickShare, onClose }) => {
  return (
    <>
      <div className="w-full my-10 text-4xl font-bold text-center">エントリー完了!!</div>
      <div className="flex justify-center mb-10 mr-4">
        <img src="/assets/success-cat.png" alt="success-cat" width={198} />
      </div>
      <div className="px-4 my-4">
        <PrimaryButton content={"このクイズをシェアする"} onClick={onClickShare} className="w-full" />
      </div>

      <div className="text-center text-sm text-primary underline cursor-pointer mb-7" onClick={onClose}>
        閉じる
      </div>
    </>
  );
};
